import { ROUTE_EVENTS_ROOT } from './constants';
import CityEventsRoot from './CityEventsRoot';

export default {
  path: ROUTE_EVENTS_ROOT,
  indexRoute: {
    name: 'cityEventsList',
    component: CityEventsRoot
  },
}



// WEBPACK FOOTER //
// ./src/components/CityEvents/router.js